import React from "react";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

const CardComponent = (props) => {
  return (
    <Card
      sx={{
        display: "inline-flex",
        my: 2,
        mx: 1,
        width: "45%",
        justifyContent: "space-between",
        flexDirection: "column",
        boxShadow: 'none'
      }}
    >
      <CardMedia
        component="img"
        sx={{ width: 100, height: 100, mx: 'auto' }}
        image={`/assets/products/${props.title.split(' ')[0]}.jpg`}
        alt={props.title}
      />
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <CardContent sx={{ flex: "1 0 auto", py: 0 }}>
          <Typography
            sx={{ textAlign: "center", py: 1 }}
            variant="subtitle1"
            color="text.secondary"
            component="div"
            dir="ltr"
          >
            {props.title}
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
};

export default CardComponent;
